/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddClientTeamMember200ResponseUser } from './AddClientTeamMember200ResponseUser';
import {
    AddClientTeamMember200ResponseUserFromJSON,
    AddClientTeamMember200ResponseUserFromJSONTyped,
    AddClientTeamMember200ResponseUserToJSON,
    AddClientTeamMember200ResponseUserToJSONTyped,
} from './AddClientTeamMember200ResponseUser';

/**
 * Created user object.
 * @export
 * @interface AddClientTeamMember200Response
 */
export interface AddClientTeamMember200Response {
    /**
     * 
     */
    user?: AddClientTeamMember200ResponseUser;
}

/**
 * Check if a given object implements the AddClientTeamMember200Response interface.
 */
export function instanceOfAddClientTeamMember200Response(value: object): value is AddClientTeamMember200Response {
    return true;
}

export function AddClientTeamMember200ResponseFromJSON(json: any): AddClientTeamMember200Response {
    return AddClientTeamMember200ResponseFromJSONTyped(json, false);
}

export function AddClientTeamMember200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddClientTeamMember200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'] == null ? undefined : AddClientTeamMember200ResponseUserFromJSON(json['user']),
    };
}

export function AddClientTeamMember200ResponseToJSON(json: any): AddClientTeamMember200Response {
    return AddClientTeamMember200ResponseToJSONTyped(json, false);
}

export function AddClientTeamMember200ResponseToJSONTyped(value?: AddClientTeamMember200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': AddClientTeamMember200ResponseUserToJSON(value['user']),
    };
}

